export default __webpack_public_path__ + "static/media/stat2.e8f6ccdf.png";